import { Component, OnInit, Output, EventEmitter} from '@angular/core';
import { Subject } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertHelper } from 'src/app/shared/components/helpers/alert.helpers';
import { Nacionalidades } from 'src/app/shared/models/nacionalidades.interface';
import { NacionalidadesService } from 'src/app/pages/services/nacionalidades.service';
import { debounceTime } from 'rxjs/operators';

@Component({
  selector: 'app-agregar-nacionalidades',
  templateUrl: './agregar-nacionalidades.component.html',
  styleUrls: ['./agregar-nacionalidades.component.css']
})
export class AgregarNacionalidadesComponent implements OnInit {

  @Output() onDebounce: EventEmitter<boolean> = new EventEmitter();
  debouncer: Subject<boolean> = new Subject();

  nacionalidades:Nacionalidades={
    nombre:"",            
  }
  
  constructor(
    private modalService: NgbModal,
    private alert: AlertHelper,
    private nacionalidadesService: NacionalidadesService,
  ) { }

  ngOnInit(): void {
    this.debouncer
      .pipe(debounceTime(500))
      .subscribe( valor => {
        this.onDebounce.emit( valor );
      });
  }

  open(content:any){
    this.limpiar_Nacionalidad();
    this.modalService.open(content);
  }

  validarNacionalidad(){
    if(this.nacionalidades.nombre.trim().length==0){
      this.alert.errorAlert('Los campos no pueden estar vacios.')
    }
  }

  limpiar_Nacionalidad(){
    this.nacionalidades.nombre=""; 
  }

  agregar(){

    this.validarNacionalidad()
      this.nacionalidadesService.crearNacionalidad(this.nacionalidades).subscribe((res:any)=>{
        if (res.success==true) {
          this.alert.success_small("nacionalidad creada con exito")
          this.modalService.dismissAll();
          this.limpiar_Nacionalidad();
         
          this.debouncer.next( true );
        }else{
          this.alert.error_small(res.msg!)
        }
    })
   
  }

}
